/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  Series,
  AggregateValuesType,
} from '..';

import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface GetLastAggregateInput {
  serial: string;
  series: Series;
  type: string;
}
const build = (_query: DocumentNode, input: GetLastAggregateInput, name = 'QueryResult') => {
  const bQuery = `
  query ${ name }(`+
    ( input.serial !== undefined ? `$serial: String = ${JSON.stringify(input.serial).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.series !== undefined ? `$series: Series = ${input.series}, ` : '' ) + ``+
    ( input.type !== undefined ? `$type: String = ${JSON.stringify(input.type).replace(/"(\w+)":/g, '$1:')}` : '' ) + `){
    getLastAggregate(
      ${ input.serial !== undefined ? 'serial: $serial,' : '' } 
      ${ input.series !== undefined ? 'series: $series,' : '' } 
      ${ input.type !== undefined ? 'type: $type,' : '' }
    ){
      ...aggregatevaluestype
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class GetLastAggregateQuery {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment aggregatevaluestype on AggregateValuesType { ... }
   */
  async execute(_query: DocumentNode, input: GetLastAggregateInput, refresh = false) {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    const fetchPolicy = refresh ? 'network-only' : 'cache-first';
   return await client?.query<{ getLastAggregate: Partial<AggregateValuesType>[] }>({ query: build(_query, input), fetchPolicy });
  }
}
